import React, { lazy, Suspense } from 'react';

import { LAZY_LOADING_TIMEOUT_MS } from '../../config/constants';
import type { ProjectMapProps } from './index.lazy';

const ProjectMap: React.FC<ProjectMapProps> = lazy(
  () => new Promise<typeof import('./index.lazy')>((resolve) => {
    setTimeout(() => {
      resolve(import('./index.lazy'));
    }, LAZY_LOADING_TIMEOUT_MS);
  }),
);

const ProjectMapSuspense: React.FC<ProjectMapProps> = (props) => (
  <Suspense fallback={<div />}>
    <ProjectMap {...props} />
  </Suspense>
);

export default ProjectMapSuspense;

